<!--  /**
     * 轨迹完整分析的百度地图2
     * @jlliang
     */-->
<template>
    <div style="height: 100%;width: 100%">
        <div style="position: absolute;left: 10px;top: 10px;z-index: 9999">
            <van-button size="mini" type="info" z-index="9999" @click="onback">返回</van-button>
        </div>
        <div id="map" v-bind:style="{width:windowwidth+'px',height:windowheight+'px'}"></div>
        <!--        <div v-for="item in list">-->
        <div>
            <Table :columns="columns1" :data="data1"></Table>
        </div>
        <div>
            <Table :columns="columns2" :data="data2"></Table>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import store from '@/store'
    import {GPS} from '@/libs/positonUtils'
    import {
        Cell,
        CellGroup,
        Field,
        Row,
        Col,
        Button,
        Dialog,
        Radio,
        RadioGroup,
        Checkbox,
        CheckboxGroup,
        Picker,
        Popup,
        Divider,
        Collapse,
        CollapseItem,
        DatetimePicker,
        Tag,
        DropdownMenu,
        DropdownItem,
        Sticky,
        Icon,
        Search,
        PullRefresh,
        List,
        Loading,
        Toast,
    } from 'vant'


    Vue.use(Cell).use(CellGroup).use(Field).use(Row).use(Col).use(Button).use(Dialog).use(Radio).use(Tag).use(DropdownMenu)
        .use(RadioGroup).use(Checkbox).use(CheckboxGroup).use(Picker).use(Popup).use(Divider).use(Collapse).use(CollapseItem)
        .use(DatetimePicker).use(Icon).use(DropdownItem).use(Sticky).use(Search).use(PullRefresh).use(List).use(Loading).use(Toast);

    export default {
        name: "BDmap2",
        data() {
            return {
                windowwidth: '',
                windowheight: '',
                BDmap: '',

                polylinePath1: '',

                discontinuousTracksPolyline: [],
                shiftTracksPolyline: [],
                show:true,

                columns1: [
                    {
                        title: '开始时间',
                        key: 'startDatetime',
                        align: 'center',
                        render: (h, params) => {
                            let aa = params.row.startDatetime
                            return h('div', new Date(aa).Format('yyyy-MM-dd hh:mm:ss'));
                        }
                    },
                    {
                        title: '结束时间',
                        key: 'endDatetime',
                        align: 'center',
                        render: (h, params) => {
                            let aa = params.row.endDatetime
                            return h('div', new Date(aa).Format('yyyy-MM-dd hh:mm:ss'));
                        }
                    },
                    {
                        title: '里程',
                        key: 'discontinuousTracks',
                        align: 'center',
                        render: (h, params) => {
                            console.log(params.row)
                            console.log(params.row.mileage)
                            let aa = (params.row.mileage) / 10
                            return h('div', aa);
                        }
                    },
                    {
                        title: '操作',
                        key: 'action',
                        width: 70,
                        align: 'center',
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'primary',
                                        size: 'small'
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: () => {
                                            this.remove_overlay(params.row)
                                        }
                                    }
                                }, '显示'),
                            ]);
                        }
                    }
                ],
                data1: [],
                columns2: [
                    {
                        title: '开始时间',
                        key: 'startDatetime',
                        align: 'center',
                        render: (h, params) => {
                            let aa = params.row.startDatetime
                            return h('div', new Date(aa).Format('yyyy-MM-dd hh:mm:ss'));
                        }
                    },
                    {
                        title: '结束时间',
                        key: 'endDatetime',
                        align: 'center',
                        render: (h, params) => {
                            let aa = params.row.endDatetime
                            return h('div', new Date(aa).Format('yyyy-MM-dd hh:mm:ss'));
                        }
                    },
                    {
                        title: '里程',
                        key: 'shiftTracksList',
                        align: 'center',
                        render: (h, params) => {
                            console.log(params.row)
                            console.log(params.row.mileage)
                            let aa = (params.row.mileage) / 10
                            return h('div', aa);
                        }
                    },
                    {
                        title: '操作',
                        key: 'action',
                        width: 70,
                        align: 'center',
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'primary',
                                        size: 'small'
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: () => {
                                            this.remove_overlay(params.row)
                                        }
                                    }
                                }, '显示'),
                            ]);
                        }
                    }
                ],
                data2: []
            }
        },
        methods: {
            remove_overlay(e) {
                // if (this.discontinuousTracksPolyline) {
                //     for (let i = 0; i < this.discontinuousTracksPolyline.length; i++) {
                //         if (this.discontinuousTracksPolyline[i].trackId === e.id) {
                //             if (this.discontinuousTracksPolyline[i].map == null) {
                //                 this.BDmap.addOverlay(this.discontinuousTracksPolyline[i])
                //             } else {
                //                 this.BDmap.removeOverlay(this.discontinuousTracksPolyline[i])
                //             }
                //             break
                //         }
                //     }
                // }

                console.log(e)
                console.log(this.discontinuousTracksPolyline)
                console.log(this.BDmap.getOverlays())
                let all = this.BDmap.getOverlays()
                for (let i = 0; i < all.length; i++) {
                    if (e.id === all[i].trackId) {
                        console.log(e.id)
                        console.log(all[i].trackId)
                        if (this.show == true) {
                        all[i].hide()
                            this.show = false
                        }else {
                            all[i].show()
                            this.show = true
                        }
                    }
                }
            },
            onback() {
                this.$router.push({
                    name: 'tracksintegrityanalysiss'
                })
            },
            // 定位
            location() {
                let that = this

                function myFun(result) {
                    var cityName = result.name
                    that.BDmap.setCenter(cityName)
                    // alert('当前定位城市:' + cityName)
                }

                var myCity = new BMap.LocalCity()
                myCity.get(myFun)
            },
        },
        mounted() {
            console.log(window.innerWidth)
            console.log(window.innerHeight)
            this.windowwidth = window.innerWidth
            this.windowheight = window.innerHeight * 0.7
            // 百度地图API功能
            this.BDmap = new BMap.Map('map')
            var poi = new BMap.Point(116.307852, 40.057031)

            // 添加定位控件
            var geolocationControl = new BMap.GeolocationControl()
            geolocationControl.addEventListener('locationSuccess', function (e) {
                // 定位成功事件
                var address = ''
                address += e.addressComponent.province
                address += e.addressComponent.city
                address += e.addressComponent.district
                address += e.addressComponent.street
                address += e.addressComponent.streetNumber
                alert('当前定位地址为：' + address)
            })
            geolocationControl.addEventListener('locationError', function (e) {
                // 定位失败事件
                alert(e.message)
            })
            this.location()
            this.BDmap.addControl(geolocationControl)
            this.BDmap.centerAndZoom(poi, 10)
            this.BDmap.enableScrollWheelZoom(true)
            // 添加缩略图控件
            // this.BDmap.addControl(new BMap.OverviewMapControl({ isOpen: false, anchor: BMAP_ANCHOR_BOTTOM_RIGHT }))
            // 添加缩放平移控件
            this.BDmap.addControl(new BMap.NavigationControl())
            // 添加比例尺控件
            this.BDmap.addControl(new BMap.ScaleControl())
            // 添加地图类型控件
            // map.addControl(new BMap.MapTypeControl());

            // var polyline = new BMap.Polyline([
            //     new BMap.Point(116.399, 39.910),
            //     new BMap.Point(116.405, 39.920),
            //     new BMap.Point(116.425, 39.900)
            // ], {strokeColor:"blue", strokeWeight:2, strokeOpacity:0.5});   //创建折线
            //
            // //添加覆盖物
            //     this.BDmap.addOverlay(polyline);          //增加折线

            console.log(this.$route.params.item)
            //全日折线
            store.dispatch('LocateHistoryServ_LoadDailyTrack', {
                params: {
                    terminalNum: this.$route.params.item.terminalNum,
                    selectDatetime: new Date(this.$route.params.item.analyzeDatetime).Format(('yyyy-MM-dd hh:mm:ss')),
                },
                urlparams: null
            }).then((res) => {
                console.log(res)
                this.polylinePath1 = []

                // WGS-84 转 GCJ-02
                let gcj02 = []
                for (var q = 0; q < res.data.length; q++) {
                    // console.log(wgs84[q])
                    let gcj = GPS.gcj_encrypt(res.data[q].latitude, res.data[q].longitude)
                    // console.log(gcj)
                    gcj02.push({lat: gcj.lat, lon: gcj.lon})
                }
                // console.log(gcj02)

                // GCJ-02 转 BD-09
                let bd09 = []
                for (var w = 0; w < gcj02.length; w++) {
                    let bd = GPS.bd_encrypt(gcj02[w].lat, gcj02[w].lon)
                    // console.log(bd)
                    bd09.push({lat: bd.lat, lon: bd.lon})
                }

                for (let i = 0; i < bd09.length; i++) {
                    this.polylinePath1.push(
                        new BMap.Point(bd09[i].lon, bd09[i].lat)
                    )
                }
                console.log(this.polylinePath1)
                let polyline1 = new BMap.Polyline(this.polylinePath1, {
                    strokeColor: "blue",
                    strokeWeight: 3,
                    strokeOpacity: 1
                })
                this.BDmap.addOverlay(polyline1);          //增加折线
                var newpoi = new BMap.Point(bd09[bd09.length - 1].lon, bd09[bd09.length - 1].lat)
                this.BDmap.centerAndZoom(newpoi, 11)


                //不连续轨迹折线
                if (this.$route.params.item.discontinuousTracksList) {
                    console.log(this.$route.params.item.discontinuousTracksList)
                    console.log(JSON.parse(this.$route.params.item.discontinuousTracksList))
                    console.log(JSON.parse(this.$route.params.item.discontinuousTracksList).discontinuousTracksList)
                    let polyline2 = JSON.parse(this.$route.params.item.discontinuousTracksList).discontinuousTracksList
                    for (let i = 0; i < polyline2.length; i++) {
                        // for (let j = 0; j < polyline2[i].discontinuousTracks.length; j++) {

                        // WGS-84 转 GCJ-02
                        let gcj02 = []
                        for (var q = 0; q < polyline2[i].discontinuousTracks.length; q++) {
                            // console.log(wgs84[q])
                            let gcj = GPS.gcj_encrypt(polyline2[i].discontinuousTracks[q].lat, polyline2[i].discontinuousTracks[q].lng)
                            // console.log(gcj)
                            gcj02.push({lat: gcj.lat, lon: gcj.lon})
                        }
                        // console.log(gcj02)

                        // GCJ-02 转 BD-09
                        let bd09 = []
                        for (var w = 0; w < gcj02.length; w++) {
                            let bd = GPS.bd_encrypt(gcj02[w].lat, gcj02[w].lon)
                            // console.log(bd)
                            bd09.push({lat: bd.lat, lon: bd.lon})
                        }

                        let polylinePath2 = []
                        for (let i = 0; i < bd09.length; i++) {
                            polylinePath2.push(
                                new BMap.Point(bd09[i].lon, bd09[i].lat)
                            )
                        }
                        // }
                        let polyline = new BMap.Polyline(polylinePath2, {
                            strokeColor: "red",
                            strokeWeight: 3,
                            strokeOpacity: 1
                        })
                        // polyline.setMap(this.BDmap)
                        this.BDmap.addOverlay(polyline);          //增加折线
                        polyline.trackId = polyline2[i].id
                        this.discontinuousTracksPolyline.push(polyline)
                        this.discontinuousTracksPolyline.forEach(item => {
                            // item.setMap(this.BDmap)
                            this.BDmap.addOverlay(item);          //增加折线
                        })
                    }
                }

                //漂移轨迹折线shiftTracksPolyline
                if (this.$route.params.item.shiftTracksList) {discontinuousTracksList
                    console.log(this.$route.params.item.shiftTracksList)
                    console.log(JSON.parse(this.$route.params.item.shiftTracksList))
                    console.log(JSON.parse(this.$route.params.item.shiftTracksList).shiftTracksList)
                    let polyline3 = JSON.parse(this.$route.params.item.shiftTracksList).shiftTracksList
                    for (let i = 0; i < polyline3.length; i++) {
                        // for (let j = 0; j < polyline3[i].discontinuousTracks.length; j++) {

                        // WGS-84 转 GCJ-02
                        let gcj02 = []
                        for (var q = 0; q < polyline3[i].shiftTracks.length; q++) {
                            // console.log(wgs84[q])
                            let gcj = GPS.gcj_encrypt(polyline3[i].shiftTracks[q].lat, polyline3[i].shiftTracks[q].lng)
                            // console.log(gcj)
                            gcj02.push({lat: gcj.lat, lon: gcj.lon})
                        }
                        // console.log(gcj02)

                        // GCJ-02 转 BD-09
                        let bd09 = []
                        for (var w = 0; w < gcj02.length; w++) {
                            let bd = GPS.bd_encrypt(gcj02[w].lat, gcj02[w].lon)
                            // console.log(bd)
                            bd09.push({lat: bd.lat, lon: bd.lon})
                        }

                        let polylinePath2 = []
                        for (let i = 0; i < bd09.length; i++) {
                            polylinePath2.push(
                                new BMap.Point(bd09[i].lon, bd09[i].lat)
                            )
                        }
                        // }
                        let polyline = new BMap.Polyline(polylinePath2, {
                            strokeColor: "Orchid",
                            strokeWeight: 3,
                            strokeOpacity: 1
                        })
                        // polyline.setMap(this.BDmap)
                        this.BDmap.addOverlay(polyline);          //增加折线
                        polyline.shifttrackId = polyline3[i].id
                        this.shiftTracksPolyline.push(polyline)
                        this.shiftTracksPolyline.forEach(item => {
                            // item.setMap(this.BDmap)
                            this.BDmap.addOverlay(item);          //增加折线
                        })
                    }
                }
            }).catch((err) => {
                console.log(err)
            })


            if (this.$route.params.item.discontinuousTracksList) {
                this.data1 = JSON.parse(this.$route.params.item.discontinuousTracksList).discontinuousTracksList
            }
            if (this.$route.params.item.shiftTracksList) {
                this.data2 = JSON.parse(this.$route.params.item.shiftTracksList).shiftTracksList
            }
        },
    }
</script>

<style scoped>

</style>
